import { useEffect, useState } from "react";
import AlertPopup from "../../../../components/common/alertPopup/AlertPopup";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ManageInvoice from "../../invoice/ManageInvoice";
import {
  getConfirmationAction,
  getLeadConfirmationLinkAction,
  setLeadConfirmationDownloaded,
} from "../../../../store/reducers/clientConfirmationSlice";
import AlertOnSaveConfirmation from "../../manageLeads/AlertOnSaveConfirmation";
import { setDeletedInvoiceResponse } from "../../../../store/reducers/invoiceSlice";
import ManageDepositInvoice from "../../invoice/ManageDepositInvoice";

const popupTitle: any = {
  email: "Lead Estimate Email",
  pdf: "Lead Estimate PDF",
  odt: "Lead Estimate ODT",
};

const popupTitleQuote: any = {
  email: "Lead Confirmation Email",
  pdf: "Lead Confirmation PDF",
  odt: "Lead Confirmation ODT",
  previous: "Lead Previous Quote",
};

const popupContent: any = {
  email: "Are you sure you want to send an email?",
  pdf: "Are you sure you want to download the PDF?",
  odt: "Are you sure you want to download the ODT?",
  previous: "Are you sure you want to download it?",
};

interface ConfirmationActionsPopupProps {
  confirmationForm: any;
  deleteRec?: string;
  onHide?: () => void;
  setDeleteModalShow?: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  clientDetails?: any;
  setIsUpdated?: any;
  screenType?: any;
  setIsShowActionCalled?: any;
  isShowActionCalled?: any;
  setAnyChangeFieldValue?: any;
  anyChangeFieldValue?: any;
  actionType?: any;
  setActionType?: any;
}

const ConfirmationActions: React.FC<ConfirmationActionsPopupProps> = ({
  confirmationForm,
  screenType = "",
  isShowActionCalled,
  setIsShowActionCalled,
  setAnyChangeFieldValue,
  anyChangeFieldValue,
  actionType,
  setActionType,
}) => {
  const [open, setOpen] = useState(false);
  const [invoiceModel, setInvoiceModel] = useState(false);

  const { isFileDownloaded, toolTipResponse } = useSelector(
    (state: any) => state.confirmation
  );
  const { isDeletedInvoiceResponse } = useSelector(
    (state: any) => state.invoice
  );
  const { leadDetails } = useSelector((state: any) => state.lead);
  const [pendingActionType, setPendingActionType] = useState("");
  const [alertModelShow, setAlertModelShow] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isFileDownloaded) {
      // submitHandler();
      dispatch(setLeadConfirmationDownloaded(false));
      onHide();
    }
  }, [isFileDownloaded]);

  const onHide = () => {
    setOpen(false);
  };

  const onShow = (type: any) => {
    // setOpen(true);
    setActionType(type);
    setIsShowActionCalled(true);
  };

  const submitHandler = (typeParam?: string) => {
    const finalType = typeParam || actionType;
    dispatch(
      getLeadConfirmationLinkAction({
        leadId: leadDetails?.lead?.generated_id,
        ...confirmationForm,
        type: finalType,
        screenType,
      })
    );
    setIsShowActionCalled(false);
    setActionType("");
    setAnyChangeFieldValue(false);
  };

  const handleClose = () => {
    setInvoiceModel(false);
    dispatch(getConfirmationAction(leadDetails?.lead?.generated_id));
  };
  const handleInvoice = () => {
    setInvoiceModel(true);
  };

  useEffect(() => {
    if (actionType) {
      if (
        confirmationForm?.confirmationId &&
        leadDetails?.lead?.generated_id &&
        actionType
      ) {
        submitHandler(actionType);
      } else {
        setIsShowActionCalled(false);
      }
      setIsShowActionCalled(false);
    }
  }, [actionType]);

  const isCheckedQuoteStatus = leadDetails?.lead?.status === "QUOTE";

  // 🆕 main click handler
  const handleActionClick = (type: string) => {
    if (isCheckedQuoteStatus) {
      // open modal first
      setPendingActionType(type);
      setAlertModelShow(true);
    } else {
      // directly call existing logic
      onShow(type);
    }
  };

  // 🆕 called when modal submit is clicked
  const handleModalSubmit = () => {
    setAlertModelShow(false);
    if (pendingActionType) {
      onShow(pendingActionType);
      setPendingActionType("");
    }
  };

  useEffect(() => {
    if (isDeletedInvoiceResponse) {
      setInvoiceModel(false);
      dispatch(setDeletedInvoiceResponse(false));
    }
  }, [isDeletedInvoiceResponse]);

  return (
    <>
      {alertModelShow && (
        <AlertOnSaveConfirmation
          open={alertModelShow}
          title="Confirmation"
          onHide={() => setAlertModelShow(false)}
          setAlertModelShow={setAlertModelShow}
          submitHandler={handleModalSubmit} // 🆕 calls onShow(type)
        />
      )}
      {invoiceModel && (
        <ManageDepositInvoice
          title={"Deposit Invoice"}
          open={invoiceModel}
          onHide={handleClose}
          invoiceType="deposit"
          isSetLeadDetails={false}
          isNewInvoice={false}
          selectedInvoice={null}
          selectedQuote={confirmationForm}
        />
        // <ManageInvoice
        //   title="Invoice"
        //   open={invoiceModel}
        //   onHide={handleClose}
        //   invoiceType="deposit"
        //   isFormReadyOnly={false}
        //   isSetLeadDetails={false}
        //   isNewInvoice={false}
        //   isCompletionInvoice={false}
        // />
      )}
      <CustomButton
        disabled={
          screenType === "confirmation"
            ? confirmationForm?.invoiceNumber
              ? false
              : true
            : true
        }
        style={{ marginRight: "10px" }}
        title="Deposit"
        onClick={() => handleInvoice()}
      />
      <CustomButton
        disabled={!confirmationForm?.isDepositeRecieved}
        // disabled={
        //   screenType === "confirmation"
        //    &&
        //        confirmationForm?.confirmationId
        //         ? false
        //         : true
        // }
        style={{ marginRight: "10px" }}
        title="Email"
        // onClick={() => onShow("email")}
        onClick={() => handleActionClick("email")}
      />
      <CustomButton
        disabled={!confirmationForm?.isDepositeRecieved}
        // disabled={
        //   screenType === "confirmation" &&  confirmationForm?.confirmationId ? false: true
        // }
        style={{ marginRight: "10px" }}
        title="PDF"
        // onClick={() => onShow("pdf")}
        onClick={() => handleActionClick("pdf")}
      />
      {/* Todo */}

      <CustomButton
        disabled={
          screenType === "confirmation" &&
          confirmationForm?.confirmationId &&
          confirmationForm?.isDepositeRecieved
            ? false
            : true
        }
        style={{ marginRight: "10px" }}
        title="ODT"
        // onClick={() => onShow("odt")}
        onClick={() => handleActionClick("odt")}
      />
      {/* {screenType === "confirmation" && <CustomButton
                disabled={
                    screenType === "confirmation" ?
                    (confirmationForm?.quoteId && confirmationForm?.count > 1) ? false : true :
                    confirmationForm?.estimateId ? false : true
                }
                style={{ marginRight: "20px", marginTop: "5px", float: "right" }} title="Previous Quote" onClick={()=>onShow('previous')}
            />} */}
      <AlertPopup
        open={open}
        onHide={onHide}
        title={
          screenType === "confirmation"
            ? popupTitleQuote[actionType]
            : popupTitle[actionType]
        }
        content={popupContent[actionType]}
        submitHandler={submitHandler}
      />
    </>
  );
};

export default ConfirmationActions;
